'use client';

import { useEffect } from 'react';
import { reportError } from '@/lib/error-reporting';

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, {
      context: 'render:error-boundary',
      extra: { digest: error.digest ?? null },
    });
  }, [error]);

  return (
    <div
      style={{
        padding: 'var(--space-3xl)',
        maxWidth: 480,
        margin: `var(--space-5xl) auto`,
        fontFamily: 'var(--font-sans)',
        textAlign: 'center',
      }}
    >
      <h2 style={{ fontFamily: 'var(--font-sans)', fontSize: 20, marginBottom: 'var(--space-md)' }}>
        No pudimos cargar esta pantalla.
      </h2>
      <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 'var(--space-2xl)' }}>
        Ya quedó registrado. Reintenta o recarga la página.
      </p>
      <button type="button"
        onClick={reset}
        style={{
          padding: `var(--space-sm) var(--space-xl)`,
          background: 'var(--accent)',
          color: 'var(--bg)',
          border: 'none',
          borderRadius: 'var(--r-md)',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          cursor: 'pointer',
          fontFamily: 'var(--font-sans)',
        }}
      >
        Reintentar
      </button>
    </div>
  );
}
